export const API_ENDPOINT = 'https://jezan.herokuapp.com';

 